import { cachePolicyMs } from "./cachePolicy";
import {
  fetchAllInterviewees,
  fetchIntervieweeDetail,
  fetchMapVillages,
  fetchVillageEvidence,
  fetchVillageInterviewees,
  fetchVillageSatellite,
  fetchVillageSummary,
  fetchVillageTags,
} from "../publicApi";
import { fetchVillageReference } from "../referenceData";

export function villageReferenceQueryOptions() {
  return {
    queryKey: ["village-reference"],
    queryFn: fetchVillageReference,
    staleTime: cachePolicyMs.referenceGeography,
  };
}

export function mapVillagesQueryOptions() {
  return {
    queryKey: ["map-villages"],
    queryFn: fetchMapVillages,
    staleTime: cachePolicyMs.mapBootstrap,
  };
}

export function villageSummaryQueryOptions(villageRef: string | null) {
  return {
    queryKey: ["village-summary", villageRef],
    queryFn: () => fetchVillageSummary(villageRef ?? ""),
    enabled: Boolean(villageRef),
    staleTime: cachePolicyMs.villageDetail,
  };
}

export function villageIntervieweesQueryOptions(villageRef: string | null) {
  return {
    queryKey: ["village-interviewees", villageRef],
    queryFn: ({ pageParam }: { pageParam: number }) => fetchVillageInterviewees(villageRef ?? "", pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage: { page: number; pageSize: number; total: number }) => {
      const nextPage = lastPage.page + 1;
      return lastPage.page * lastPage.pageSize < lastPage.total ? nextPage : undefined;
    },
    enabled: Boolean(villageRef),
    staleTime: cachePolicyMs.intervieweeListing,
  };
}

export function villageEvidenceQueryOptions(villageRef: string | null, enabled: boolean) {
  return {
    queryKey: ["village-evidence", villageRef],
    queryFn: () => fetchVillageEvidence(villageRef ?? ""),
    enabled: Boolean(villageRef) && enabled,
    staleTime: cachePolicyMs.villageDetail,
  };
}

export function villageSatelliteQueryOptions(villageRef: string | null, enabled: boolean, imageType = "satellite") {
  return {
    queryKey: ["village-satellite", villageRef, imageType],
    queryFn: () => fetchVillageSatellite(villageRef ?? "", imageType),
    enabled: Boolean(villageRef) && enabled,
    staleTime: cachePolicyMs.villageDetail,
  };
}

export function intervieweeDetailQueryOptions(intervieweeRef: string | null) {
  return {
    queryKey: ["interviewee-detail", intervieweeRef],
    queryFn: () => fetchIntervieweeDetail(intervieweeRef ?? ""),
    enabled: Boolean(intervieweeRef),
    staleTime: cachePolicyMs.intervieweeDetail,
  };
}

export function allIntervieweesQueryOptions(page: number, pageSize: number, query: string) {
  return {
    queryKey: ["all-interviewees", page, pageSize, query],
    queryFn: () => fetchAllInterviewees(page, pageSize, query),
    staleTime: cachePolicyMs.intervieweeListing,
  };
}

export function villageTagsQueryOptions(villageRef: string | null) {
  return {
    queryKey: ["village-tags", villageRef],
    queryFn: () => fetchVillageTags(villageRef ?? ""),
    enabled: Boolean(villageRef),
    staleTime: cachePolicyMs.referenceGeography,
  };
}
